function CGForgotPasswordViewModel(options) {
    this.username = ko.observable(options.username);
    this.isInternalRequest = options.isInternalRequest;
    this.loading = ko.observable(false);
    this.alert = new AlertViewModel();

    this.resetButtonEnabled = ko.computed(function () {
        var loading = this.loading();
        var userNameFilled = this.username().length > 0;

        return !loading && userNameFilled;
    }, this);

    this.submit = function () {
        var self = this;
        if (!self.resetButtonEnabled())
            return;

        this.loading(true);

        $.post(Cartegraph.AjaxURL.Account("EmailResetLink"), { userName: self.username(), isInternalRequest: self.isInternalRequest })
            .then(function (data) {
                self.loading(false);
                if (data.success)
                    self.alert.warning(data.message, data.title, { ok: "OK" });
                else
                    self.alert.error(data.message, data.title, { ok: "OK" });
            }, function (data) {
                self.loading(false);
                self.alert.error(Cartegraph.Resources.ResetPasswordFailed, Cartegraph.Resources.AskYourSystemAdminForHelpPeriod, { ok: "OK" });
            });
    };

    this.backToSignIn = function () {
        var self = this;
        window.location = Cartegraph.AjaxURL.Account("ShowSignIn", { isInternalRequest: self.isInternalRequest });
    }
};

function CGResetPasswordViewModel(options) {
    this.username = ko.observable(options.username);
    this.newPassword = ko.observable("");
    this.confirmPassword = ko.observable("");
    this.loading = ko.observable(false);
    this.error = ko.observable(options.error);
    this.key = options.key;
    this.isInternalRequest = options.isInternalRequest;

    this.resetButtonEnabled = ko.computed(function () {
        var loading = this.loading();
        var newPassword = this.newPassword();
        var confirmPassword = this.confirmPassword();

        return !loading && newPassword.length > 0 && newPassword === confirmPassword;
    }, this);

    this.submit = function () {
        var self = this;

        if (!self.resetButtonEnabled()) {
            return;
        }
        this.loading(true);

        $.post(Cartegraph.AjaxURL.Account("ResetPassword"), {
            Key: self.key,
            UserName: self.username(),
            Password: self.newPassword(),
            ConfirmPassword: self.confirmPassword()
        })
            .then(function (data) {
                self.backToSignIn();
            }, function (data) {
                self.loading(false);
                self.error(data.responseJSON.message);
            });
    };

    this.backToSignIn = function () {
        var self = this;
        window.location = Cartegraph.AjaxURL.Account("ShowSignIn", { isInternalRequest: self.isInternalRequest });
    }
};
